<template>
  <router-link
    :to="`/Product-info/${productId}`"
    class="card"
    :key="productId"
    @click="addToRecentlyViewed"
  >
    <img :src="imgUrl" :alt="productTitle" class="product-img" />
    <p class="product-title">{{ productTitle }}</p>
    <p class="product-price">${{ productPrice }}</p>
    <div class="buttons">
      <store-button
        :border="'1px solid #000'"
        :padding="'8px'"
        :font-size="'2.4rem'"
        :color="'#000'"
        >Add to bag</store-button
      >
      <button class="wishlist-btn" @click="addToWishlist">
        <img src="/images/heart.svg" alt="heart" />
      </button>
    </div>
    <p class="product-category">{{ productCategory }}</p>
  </router-link>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    productTitle: {
      type: String,
      required: true,
    },
    productPrice: {
      type: Number,
      required: true,
    },
    productCategory: {
      type: String,
      required: true,
    },
    productId: {
      type: String,
    },
    productColor: {
      type: String,
      required: true,
    },
  },
  methods: {
    addToWishlist() {
      this.$store.dispatch("checkLoggedIn");

      const productInfo = {
        productId: this.productId,
        productTitle: this.productTitle,
        productImage: this.imgUrl,
        productPrice: this.productPrice,
        productColor: this.productColor,
      };

      const userData = this.$store.getters.userData;
      let userId = userData && userData.id ? userData.id : "guest";

      console.log("User ID:", userId);

      this.$store.dispatch("wishlist/addToWishlist", {
        userId,
        productId: productInfo.productId,
      });
    },

    addToRecentlyViewed() {
      const productInfo = {
        productId: this.productId,
        productTitle: this.productTitle,
        productImage: this.imgUrl,
        productPrice: this.productPrice,
        productColor: this.productColor,
        productCategory: this.productCategory
      };

      // 1. Получаем текущие товары из localStorage или создаём пустой массив
      const existing = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

      // 2. Проверяем, есть ли уже такой товар (по id)
      const alreadyExists = existing.find(
        (p) => p.productTitle === productInfo.productTitle
      );

      if (!alreadyExists) {
        // 3. Добавляем товар в начало массива
        existing.unshift(productInfo);

        // 4. Ограничим до 10 последних товаров
        if (existing.length > 10) existing.pop();

        // 5. Сохраняем обратно
        localStorage.setItem("recentlyViewed", JSON.stringify(existing));
      }
    },
  },
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  max-width: 33rem;
  min-width: 30rem;
  background: #fff;
  border-radius: 8px;
  padding: 0 15px 20px 15px;
}

.product-img {
  max-width: 100%;
  border-radius: 10px;
  height: 270px;
}

.product-title {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 300;
}

.product-price {
  color: #001e03;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 500;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-category {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 300;
  text-align: start;
}

.wishlist-btn {
  border: none;
  background: none;
  outline: none;
}
</style>